import React from 'react';
import { PageLayout } from 'layouts/PageLayout';
import * as styles from "./styles.module.scss"


const PriceTable = () => ( 
  <table className={ styles.PriceTable }>
    <thead>
        <tr>
            <th></th>
            <th>初診時</th>
            <th>2回目</th>
            <th>3回目以降</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <th>3割負担</th>
            <td>1500円</td>
            <td>500円</td>
            <td>400円</td>
        </tr>
        <tr>
            <th>2割負担</th>
            <td>1000円</td>
            <td>350円</td>
            <td>250円</td>
        </tr>
        <tr>
            <th>1割負担</th>
            <td>500円</td>
            <td>200円</td>
            <td>150円</td>
        </tr>
    </tbody>
  </table>
)

const SubTitle = ({ children }) => ( 
  <h2 className = {styles.SubTitle} >{ children }</h2>
)

const SubContainer = ({ children }) => ( 
  <div className = {styles.SubContainer} >{ children }</div>
)

export const Cost = () => {
  
  return (
    <>
      <PageLayout.Title>治療にかかる費用</PageLayout.Title>
      <PriceTable/>
      <p className = {styles.TextRight}>※健康保険使用時</p>
      <SubContainer>
        <SubTitle>健康保険を使わない場合</SubTitle>
        <p>
          初診　　　　　　　2000円<br/>
          ２回目以降　　　　1500円<br/>
        </p>
      </SubContainer>
      <SubContainer>
        <SubTitle>交通事故（自賠責保険適用時）</SubTitle>
        <p>0円　　例外もございます</p>
      </SubContainer>
    </>
  )
}